import { cn } from '@poseidon/components/cn';
import React, { type ComponentProps } from 'react';

import { UpdateAvailableBanner } from '~/components/UpdateAvailableBanner';

type StackProps = {
  gap?: string | number;
  direction?: 'row' | 'column';
  justifyContent?: 'start' | 'end';
  uniformChildren?: boolean;
  gridColumns?: string;
};

export type StackDivProps = React.HTMLProps<HTMLElement> & StackProps;

type PropsFullHeight = ComponentProps<'div'> & {
  style?: React.CSSProperties;
};

export function FullHeight({ children, className, style, ref }: PropsFullHeight) {
  return (
    <div
      className={cn('flex h-full w-full flex-col items-stretch justify-stretch overflow-hidden', className)}
      style={style}
      ref={ref}>
      <UpdateAvailableBanner />
      {children}
    </div>
  );
}

export function FlexGrowHeight({ className, ...props }: PropsFullHeight) {
  return <div className={cn('relative flex w-full grow items-stretch justify-stretch', className)} {...props} />;
}
type WithLeftNav = ComponentProps<'div'> & {
  hasDetail: boolean;
  detailSize?: 'small';
};
export const WithLeftNav = ({ children, hasDetail, detailSize }: WithLeftNav) => {
  return (
    <div
      className={cn(
        'relative ml-(--nav-width) flex grow flex-col items-stretch justify-stretch overflow-hidden bg-slate-50 font-sans text-slate-600 transition-[margin] dark:bg-neutral-800 dark:text-white',
        {
          'lg:mr-(--detail-width)': hasDetail,
          'lg:mr-[260px]': detailSize,
        },
      )}>
      {children}
    </div>
  );
};

interface WithOutLeftNav extends ComponentProps<'div'> {
  hasDetail: boolean;
  detailSize?: 'small';
}
export const WithOutLeftNav = ({ children, hasDetail, detailSize }: WithLeftNav) => {
  return (
    <div
      className={cn(
        'relative ml-0 flex grow flex-col items-stretch justify-stretch overflow-hidden bg-slate-50 font-sans text-slate-600 transition-[margin] dark:bg-neutral-800 dark:text-white',
        {
          'lg:mr-(--detail-width)': hasDetail,
          'lg:mr-[260px]': detailSize,
        },
      )}>
      {children}
    </div>
  );
};
